import { push } from 'react-router-redux'
import { arrayOf } from 'normalizr'
import uniq from 'lodash.uniq'

import { fetch, schemas } from '../utils/fetch'
import { ENDPOINT_QUEUES, ENDPOINT_QUEUE, ENDPOINT_NEW_QUEUE, ENDPOINT_CHECK_CONFLICTS } from '../constants'

const QUEUES_REQUEST = 'blayzr/queues/REQUEST'
const QUEUES_SUCCESS = 'blayzr/queues/SUCCESS'
const QUEUES_FAILURE = 'blayzr/queues/FAIL'

const SAVE_QUEUE_REQUEST = 'blayzr/queues/SAVE_REQUEST'
const SAVE_QUEUE_SUCCESS = 'blayzr/queues/SAVE_SUCCESS'
const SAVE_QUEUE_FAILURE = 'blayzr/queues/SAVE_FAIL'

const DELETE_QUEUE = 'blayzr/queues/DELETE'

const initialState = {
  data: null,
  fetching: false,
  error: null,
  submitting: false,
  submitError: null
}

export default function reducer (state = initialState, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case QUEUES_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case QUEUES_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: state.data ? uniq(state.data.concat(payload.result.records)) : payload.result.records
      }
    case QUEUES_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload.error
      }
    case SAVE_QUEUE_REQUEST:
      return {
        ...state,
        submitting: true,
        submitError: false
      }
    case SAVE_QUEUE_SUCCESS:
      return {
        ...state,
        submitting: false,
        data: state.data && state.data.indexOf(meta.id) === -1 ? [meta.id].concat(state.data) : state.data
      }
    case SAVE_QUEUE_FAILURE:
      return {
        ...state,
        submitting: false,
        submitError: payload
      }
    case DELETE_QUEUE:
      if (state.data) {
        return {
          ...state,
          data: state.data.filter(id => id !== meta.id)
        }
      }
      return state
    default:
      return state
  }
}

export function queuesRequest () {
  return {
    type: QUEUES_REQUEST
  }
}

export function queuesSuccess (data) {
  return {
    type: QUEUES_SUCCESS,
    payload: data
  }
}

export function queuesFailure (error) {
  return {
    type: QUEUES_FAILURE,
    payload: { error }
  }
}

export function saveQueueRequest () {
  return {
    type: SAVE_QUEUE_REQUEST
  }
}

export function saveQueueSuccess (id, data) {
  return {
    type: SAVE_QUEUE_SUCCESS,
    payload: { entities: { queues: {
      [id]: data.entities.queues[id]
    }}},
    meta: { id }
  }
}

export function saveQueueFailure (error) {
  return {
    type: SAVE_QUEUE_FAILURE,
    payload: error
  }
}

export function fetchQueues () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token,
      schema: {
        records: arrayOf(schemas.queue)
      }
    }
    dispatch(queuesRequest())
    return fetch(ENDPOINT_QUEUES, options, dispatch).then(data => {
      dispatch(queuesSuccess(data))
    }, e => {
      dispatch(queuesFailure(e))
    })
  }
}

export function saveQueue (data, structure, id, redirect = true) {
  return (dispatch, getState) => {
    const endpoint = id ? ENDPOINT_QUEUE.replace(':id', id) : ENDPOINT_NEW_QUEUE
    const body = {
      ...data,
      json_data: JSON.stringify(structure)
    }
    const options = {
      method: 'post',
      token: getState().auth.token,
      schema: {
        records: schemas.queue
      },
      body
    }
    dispatch(saveQueueRequest())
    return fetch(endpoint, options, dispatch).then(data => {
      const id = data.result.records
      dispatch(saveQueueSuccess(id, data))
      if (redirect) {
        dispatch(push('/queues/' + id))
      }
      return data.entities.queues[id]
    }, e => {
      dispatch(saveQueueFailure(e))
    })
  }
}

export function deleteQueue (id) {
  return (dispatch, getState) => {
    const endpoint = ENDPOINT_QUEUE.replace(':id', id)
    fetch(endpoint, {
      method: 'delete',
      token: getState().auth.token
    })
    dispatch({
      type: DELETE_QUEUE,
      meta: { id },
      payload: {
        entities: {
          queues: {
            [id]: undefined
          }
        }
      }
    })
    dispatch(push('/queues'))
  }
}



// WEBPACK FOOTER //
// ./src/redux/queues.js